import { listarColeccion } from "./collections.service";

const preloadData = {};
let loaded = false;

export const preloadCollections = async () => {

  if (loaded) return;

  const collections = [
    "depositos",
    "empresas",
    "estaciones",
    "proveedores",
    "sectores",
    "ubicaciones",
  ];

  const results = await Promise.all(
    collections.map((col) => listarColeccion(col))
  );

  collections.forEach((c, i) => {
    preloadData[c] = results[i];
  });

  loaded = true;

  console.log("[Preload] Colecciones cargadas");
};

export const getPreloaded = (collection) => {
  return preloadData[collection] || [];
};